var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-plugin"
  }, [_vm.props.showStyle === 'tip' ? _c('div', {
    staticClass: "message-plugin-tip"
  }, [_vm._t("messageTip")], 2) : _vm.props.showStyle === 'bubble' ? _c('div', {
    staticClass: "message-plugin-bubble-content",
    on: {
      "longpress": function ($event) {
        return _vm.handleToggleMessageItem($event, _vm.messageModel, true);
      },
      "contextmenu": function ($event) {
        $event.preventDefault();
        return _vm.handleToggleMessageItem($event, _vm.messageModel);
      },
      "touchstart": function ($event) {
        return _vm.handleH5LongPress($event, _vm.messageModel, 'touchstart');
      },
      "touchend": function ($event) {
        return _vm.handleH5LongPress($event, _vm.messageModel, 'touchend');
      },
      "mouseover": function ($event) {
        return _vm.handleH5LongPress($event, _vm.messageModel, 'touchend');
      }
    }
  }, [_c('MessageBubble', {
    attrs: {
      "messageItem": _vm.messageModel,
      "content": _vm.messageModel.getMessageContent(),
      "blinkMessageIDList": _vm.props.blinkMessageIDList,
      "classNameList": _vm.props.bubbleClassNameList,
      "enableFeedback": _vm.props.enableFeedback,
      "enableAINote": _vm.props.enableAINote
    },
    on: {
      "resendMessage": function ($event) {
        return _vm.resendMessage(_vm.messageModel);
      },
      "like": _vm.onLike,
      "dislike": _vm.onDislike
    },
    scopedSlots: _vm._u([{
      key: "messageElement",
      fn: function () {
        return [_vm._t("messageBubble")];
      },
      proxy: true
    }], null, true)
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }